module.exports = __webpack_public_path__ + "static/media/4ODA15.f013b612.jpg";